/**
 * Configuration Defaults - v13 Section 6.10
 *
 * ╔══════════════════════════════════════════════════════════════════════════════╗
 * ║  INFRASTRUCTURE ONLY - NO MODEL DATA                                         ║
 * ║                                                                              ║
 * ║  This file contains ONLY infrastructure constants:                           ║
 * ║  - API URLs                                                                  ║
 * ║  - Cache TTL                                                                 ║
 * ║  - Empty tier structure                                                      ║
 * ║                                                                              ║
 * ║  NO BUNDLED MODEL DATA - All model info comes from provider APIs at runtime. ║
 * ║  See: apps/consumer/src/utils/fetch-models.ts                               ║
 * ╚══════════════════════════════════════════════════════════════════════════════╝
 *
 * REMOVED (previously in this file):
 * - BUNDLED_MODELS - hardcoded model metadata (context windows, pricing, etc.)
 * - BUNDLED_TIERS - hardcoded tier configuration with model names
 * - BUNDLED_FALLBACK_MODELS - hardcoded fallback model list
 * - BUNDLED_DEFAULTS - complete bundled config object
 *
 * WHY: Model data becomes stale. The API is the source of truth.
 * When a new model is released, we shouldn't need to update code.
 *
 * Last Updated: 2026-01-19
 */
/**
 * Default cache TTL (24 hours)
 * Infrastructure setting - not model data
 */
export const DEFAULT_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
/**
 * Primary data source URL
 * Infrastructure setting - not model data
 */
export const LLM_PRICES_URL = 'https://www.llm-prices.com/current-v1.json';
/**
 * Fallback data source URL
 * Infrastructure setting - not model data
 */
export const OPENROUTER_URL = 'https://openrouter.ai/api/v1/models';
/**
 * Empty tier configuration structure
 * Tiers should be configured at application level, not bundled with llm-client
 */
export const EMPTY_TIERS = {
    fast: {
        primaryModel: '',
        fallbackModels: [],
        avgCostPer1k: 0,
        description: 'Configure at application level',
    },
    standard: {
        primaryModel: '',
        fallbackModels: [],
        avgCostPer1k: 0,
        description: 'Configure at application level',
    },
    quality: {
        primaryModel: '',
        fallbackModels: [],
        avgCostPer1k: 0,
        description: 'Configure at application level',
    },
    local: {
        primaryModel: '',
        fallbackModels: [],
        avgCostPer1k: 0,
        description: 'Configure at application level',
    },
};
/**
 * Empty bundled defaults - provides structure only
 *
 * This is provided for backward compatibility with code that references BUNDLED_DEFAULTS.
 * It contains NO model data - all fields are empty.
 *
 * @deprecated Do not rely on bundled defaults. Fetch from API instead.
 */
export const BUNDLED_DEFAULTS = {
    timestamp: 0,
    source: 'bundled',
    models: {}, // No bundled models
    tiers: EMPTY_TIERS, // Empty tier structure
    fallbackModels: [], // No bundled fallbacks
};
